// Google Analytics 4 Configuration

export const GA4_CONFIG = {
  // Replace with your actual GA4 Measurement ID from Google Analytics
  MEASUREMENT_ID: 'G-XYCNZ8XVX7', // TODO: Replace with your actual GA4 ID
  
  // Analytics settings
  SETTINGS: {
    // Enable/disable analytics in development
    ENABLE_IN_DEV: false,
    
    // Enable/disable debug mode
    DEBUG_MODE: import.meta.env.DEV,
    
    // Custom dimensions (if you set them up in GA4)
    CUSTOM_DIMENSIONS: {
      // user_type: 'custom_dimension_1',
      // app_version: 'custom_dimension_2',
    },
    
    // Enhanced ecommerce settings
    ENHANCED_ECOMMERCE: {
      CURRENCY: 'USD',
      // Add more settings as needed
    }
  }
}

// Check if analytics should be enabled
export const isAnalyticsEnabled = () => {
  if (typeof window === 'undefined') return false
  
  if (import.meta.env.DEV && !GA4_CONFIG.SETTINGS.ENABLE_IN_DEV) {
    return false
  }
  
  return true
} 